import React from 'react';
import { PerformanceData } from '../types';
import { Panel } from '../components/UIComponents';
import { memoryViewStyles } from '../styles';

interface MemoryViewProps {
  request: PerformanceData;
  onBack: () => void;
  onClose: () => void;
}

export const MemoryView: React.FC<MemoryViewProps> = ({ request, onBack, onClose }) => {
  if (!request.memoryProfiler) return null;

  const retainedPercentage = (
    (request.memoryProfiler.total_retained_memsize_mb /
      Math.max(request.memoryProfiler.total_allocated_memsize_mb, 0.001)) *
    100
  ).toFixed(1);

  return (
    <Panel title={`Memory Profile - ${request.name}`} onBack={onBack} onClose={onClose} fullScreen>
      <div style={memoryViewStyles.container}>
        <h5 style={memoryViewStyles.title}>Memory Usage</h5>

        <div style={memoryViewStyles.dataRow}>
          <strong>Total Allocated:</strong> {request.memoryProfiler.total_allocated_memsize_mb.toFixed(2)} MB
        </div>

        <div style={memoryViewStyles.dataRow}>
          <strong>Total Retained:</strong> {request.memoryProfiler.total_retained_memsize_mb.toFixed(2)} MB
        </div>

        <div>
          <div style={memoryViewStyles.progressLabel}>
            <strong>Allocation Efficiency:</strong>
          </div>
          <div style={memoryViewStyles.progressContainer}>
            <div style={memoryViewStyles.progressBar(`${retainedPercentage}%`)}></div>
            <div style={memoryViewStyles.progressText}>{retainedPercentage}% retained</div>
          </div>
        </div>
      </div>

      {request.memoryProfiler && (
        <div style={memoryViewStyles.profilerData}>
          <pre style={memoryViewStyles.profilerPre}>{JSON.stringify(request.memoryProfiler, null, 2)}</pre>
        </div>
      )}
    </Panel>
  );
};
